export const featuredSymbol = "xyz-SKHX";

export const heroStats = [
	{ value: ">$39.5 billion", labelKey: "stats.trading-volume" },
	{ value: "87,400+", labelKey: "stats.users" },
	{ value: ">$15 million", labelKey: "stats.affiliate-fees" },
];

export const investors = ["HASHED", "coinbase ventures", "Ethena", "SPARTAN"];

export type LandingFeaturedMarket = {
	routeSymbol: string;
	fallbackSymbol: string;
	fallbackDisplaySymbol: string;
	fallbackName: string;
	nameKey: string;
	descriptionKey: string;
	/** oklch accent color for card glow — gives each asset a distinct tint */
	accent: string;
};

export const landingFeaturedMarkets: LandingFeaturedMarket[] = [
	{
		routeSymbol: "xyz-SKHX",
		fallbackSymbol: "SKHX",
		fallbackDisplaySymbol: "SKHYNIX-PERP",
		fallbackName: "SK hynix",
		nameKey: "markets.skhx-name",
		descriptionKey: "markets.skhx-desc",
		accent: "var(--color-theme-denotives-skyblue)", // SK blue
	},
	{
		routeSymbol: "xyz-SMSN",
		fallbackSymbol: "SMSN",
		fallbackDisplaySymbol: "SAMSUNG-PERP",
		fallbackName: "Samsung Electronics",
		nameKey: "markets.smsn-name",
		descriptionKey: "markets.smsn-desc",
		accent: "var(--color-theme-denotives-violet)", // Samsung indigo
	},
	{
		routeSymbol: "xyz-NVDA",
		fallbackSymbol: "NVDA",
		fallbackDisplaySymbol: "NVDA-PERP",
		fallbackName: "NVIDIA",
		nameKey: "markets.nvda-name",
		descriptionKey: "markets.nvda-desc",
		accent: "var(--color-theme-status-positive)", // NVIDIA green
	},
	{
		routeSymbol: "BTC",
		fallbackSymbol: "BTC",
		fallbackDisplaySymbol: "BTC-PERP",
		fallbackName: "Bitcoin",
		nameKey: "markets.btc-name",
		descriptionKey: "markets.btc-desc",
		accent: "var(--color-theme-denotives-orange)", // BTC orange
	},
	{
		routeSymbol: "xyz-CL",
		fallbackSymbol: "CL",
		fallbackDisplaySymbol: "WTIOIL-PERP",
		fallbackName: "WTI Crude Oil",
		nameKey: "markets.wti-name",
		descriptionKey: "markets.wti-desc",
		accent: "var(--color-theme-status-negative)", // Oil deep red
	},
	{
		routeSymbol: "xyz-GOLD",
		fallbackSymbol: "GOLD",
		fallbackDisplaySymbol: "GOLD-PERP",
		fallbackName: "Gold",
		nameKey: "markets.gold-name",
		descriptionKey: "markets.gold-desc",
		accent: "var(--color-theme-denotives-yellow)", // Gold amber
	},
];

export const tradeSection = {
	id: "trade",
	labelKey: "sections.trade-label",
	titleKey: "sections.trade-title",
	descriptionKey: "sections.trade-description",
};

export const walletSection = {
	id: "wallet",
	labelKey: "sections.wallet-label",
	titleKey: "sections.wallet-title",
	descriptionKey: "sections.wallet-description",
};

export const availabilitySection = {
	id: "availability",
	labelKey: "sections.availability-label",
	titleKey: "sections.availability-title",
	descriptionKey: "sections.availability-description",
};

export const predictionsSection = {
	id: "predictions",
	labelKey: "sections.predictions-label",
	titleKey: "sections.predictions-title",
	descriptionKey: "sections.predictions-description",
};

export const featuredMarketSection = {
	id: "market",
	labelKey: "sections.market-label",
	titleKey: "sections.market-title",
	descriptionKey: "sections.market-description",
};

export const cardsSection = {
	id: "cards",
	labelKey: "sections.cards-label",
	titleKey: "sections.cards-title",
	descriptionKey: "sections.cards-description",
};

export const trustSection = {
	id: "trust",
	labelKey: "sections.trust-label",
	titleKey: "sections.trust-title",
	descriptionKey: "sections.trust-description",
};

export const optimizeSection = {
	id: "optimize",
	labelKey: "sections.optimize-label",
	titleKey: "sections.optimize-title",
	descriptionKey: "sections.optimize-description",
};

export const communitySection = {
	id: "community",
	labelKey: "sections.community-label",
	titleKey: "sections.community-title",
	descriptionKey: "sections.community-description",
};

export const footerColumns = [
	{
		title: "Products",
		links: [
			{ label: "Trade", href: "#trade" },
			{ label: "Predict", href: "#predictions" },
			{ label: "Cards", href: "#cards" },
		],
	},
	{
		title: "Resources",
		links: [
			{ label: "FAQ", href: "#community" },
			{ label: "Blog", href: "#trust" },
			{ label: "Media Kit", href: "#availability" },
			{ label: "Careers", href: "#community" },
		],
	},
	{
		title: "Legal",
		links: [
			{ label: "Platform Terms", href: "#community" },
			{ label: "Card Terms", href: "#cards" },
			{ label: "Privacy Policy", href: "#wallet" },
		],
	},
];
